<ng-template #content>
  <ppl-dialog [title]="'About ' + ((identity === 'coevera') ? 'Coevera' : 'Pipeliner')"
              [actionsVisible]="false"
              (cancel)="close()">
    <div class="row">
      <div class="col">
        <div class="pipeliner-logo">
          <ppl-icon width="307px"
                    height="70px"
                    [svgIcon]="'logo-' + identity + '-blue'"></ppl-icon>
        </div>
        <div class="pipeliner-sub-logo">
          <h1 class="sub-title"
              i18n="@@PipelinerAboutBanner">Win Together!</h1>
        </div>
        <p class="long-copy"
           i18n="@@PipelinerAboutText">
          Welcome to {{(identity === 'coevera') ? 'Coevera' : 'Pipeliner'}} CRM, the people platform that empowers sales professionals, sales leaders, customers, prospects, and partners to "Win Together!"
        </p>
        <div class="url-box">
          <a href="https://www.pipelinersales.com"
             target="_blank">www.pipelinersales.com</a>
        </div>
      </div>

      <div class="col right">
        <div class="right-box">
          <div *ngIf="version"
               class="version-box">
            <p class="version font">{{(identity === 'coevera') ? 'Coevera' : 'Pipeliner'}} CRM {{ versionName }}: {{version}}
            </p>
          </div>
          <div class="version-box">
            <p class="copyright">
              <b class="font">
                <ng-container i18n="@@Constructed_by">Constructed by</ng-container>
                <br> pipelinersales.com team
              </b>
            </p>
            <p class="copyright">
              &copy; 2007-{{currentDate | date:'yyyy'}} Pipelinersales Inc. All rights reserved. {{(identity === 'coevera') ? 'Coevera' : 'Pipeliner'}} and the {{(identity === 'coevera') ? 'Coevera' : 'Pipeliner'}} Logo are registered brands or brands from
              Pipelinersales Inc.
            </p>
            <div class="condition-box font">
              <ppl-icon svgIcon="gtac"
                        width="13px"
                        height="15px"></ppl-icon>
              <a class="terms"
                 href="https://www.pipelinersales.com/terms/"
                 target="_blank">Read General Terms & Conditions</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row btn-box">
      <a #contactUsBtn
         class="btn-item"
         href="https://www.pipelinersales.com/contact/"
         style="color: white"
         target="_blank">
        <span>
          <ppl-icon [actionElement]="contactUsBtn"
                    hoverEnabled="true"
                    svgIcon="contact-us"
                    width="26px"
                    height="28px"></ppl-icon>
        </span>
        <ng-container i18n="@@Contact_Us">Contact Us</ng-container>
      </a>

      <a #introductionBtn
         class="btn-item"
         href="https://www.pipelinersales.com/knowledge/"
         style="color: white"
         target="_blank">
        <span>
          <ppl-icon [actionElement]="introductionBtn"
                    hoverEnabled="true"
                    svgIcon="introduction"
                    width="26px"
                    height="28px"></ppl-icon>
        </span>
        <ng-container i18n="@@Introduction">Introduction</ng-container>
      </a>

      <a #webinarBtn
         class="btn-item"
         href="https://www.pipelinersales.com/crm/webinars/"
         style="color: white"
         target="_blank">
        <span>
          <ppl-icon [actionElement]="webinarBtn"
                    hoverEnabled="true"
                    svgIcon="webinar"
                    width="26px"
                    height="28px"></ppl-icon>
        </span>
        <ng-container i18n="@@Webinar">Webinar</ng-container>
      </a>

      <a #realeseBtn
         class="btn-item"
         href="https://www.pipelinersales.com/crm/release-notes/"
         style="color: white"
         target="_blank">
        <span>
          <ppl-icon [actionElement]="realeseBtn"
                    hoverEnabled="true"
                    svgIcon="release-notes"
                    width="26px"
                    height="28px"></ppl-icon>
        </span>
        <ng-container i18n="@@Release_Notes">Release Notes</ng-container>
      </a>
    </div>
  </ppl-dialog>
</ng-template>
